/* Florema · detalles interactivos (oct 2026)
   1) producto vuela al carro + botón que se llena y confirma  2) precio que baja
   3) selector de aroma con pastilla que se desliza            4) cantidad que rueda
   5) favoritos (corazón + panel)                               6) cuenta regresiva que voltea
   Encendido: LIVE=true para todos; mientras tanto solo con ?micro=1 (queda en la sesión; ?micro=0 lo apaga). */
(function () {
  'use strict';
  var LIVE = true;
  try {
    if (/[?&]micro=1/.test(location.search)) sessionStorage.setItem('flMicro', '1');
    if (/[?&]micro=0/.test(location.search)) sessionStorage.removeItem('flMicro');
  } catch (e) {}
  var on = LIVE;
  try { on = on || sessionStorage.getItem('flMicro') === '1'; } catch (e) {}
  if (!on) return;
  document.documentElement.classList.add('fl-micro');
  // Vista previa del encabezado estilo Polène: ?estilo=polene (queda en la sesión; ?estilo=0 la apaga)
  try {
    if (/[?&]estilo=polene/.test(location.search)) sessionStorage.setItem('flPolene', '1');
    if (/[?&]estilo=0/.test(location.search)) sessionStorage.removeItem('flPolene');
    if (sessionStorage.getItem('flPolene') === '1') { document.documentElement.classList.add('fl-polene'); if (location.pathname === '/' || location.pathname === '') document.documentElement.classList.add('fl-home'); if (/^\/products\//.test(location.pathname)) document.documentElement.classList.add('fl-pdp'); }
  } catch (e) {}

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  function restart(el, cls) { if (!el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }
  function clp(n) { return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function num(t) { var d = String(t || '').replace(/[^\d]/g, ''); return d ? parseInt(d, 10) : 0; }
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'fl-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; restart(toastEl, 'is-on'); clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
  }

  ready(function () {
    var cartIcon = $('[data-florema-cart-icon]');

    /* ---------- 1. vuela al carro ---------- */
    function bump() { if (cartIcon) restart(cartIcon, 'fl-bump'); }
    function fly(img, desdeEl) {
      if (reduce || !img || !cartIcon) return;
      var a = img.getBoundingClientRect(), b = cartIcon.getBoundingClientRect();
      if (a.width < 20 || a.bottom < 0 || a.top > innerHeight) {
        if (!desdeEl) { bump(); return; }
        var r0 = desdeEl.getBoundingClientRect(), lado = Math.min(r0.height * 1.6, 90);
        a = { left: r0.left + r0.width / 2 - lado / 2, top: r0.top + r0.height / 2 - lado / 2, width: lado, height: lado };
      }
      var f = document.createElement('img');
      f.src = img.currentSrc || img.src; f.alt = ''; f.className = 'fl-fly';
      f.style.left = a.left + 'px'; f.style.top = a.top + 'px'; f.style.width = a.width + 'px'; f.style.height = a.height + 'px';
      document.body.appendChild(f);
      var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
      var an = f.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '12px' },
        { transform: 'translate(' + dx * 0.4 + 'px,' + (dy * 0.4 - 90) + 'px) scale(.45)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.05)', opacity: 0.3, borderRadius: '50%' }
      ], { duration: 820, easing: 'cubic-bezier(.5,0,.25,1)' });
      an.onfinish = function () { f.remove(); bump(); };
    }
    window.FloremaFly = fly;
    /* foto de origen visible en pantalla (en escritorio las fotos van una bajo otra; si ninguna se ve, la miniatura del aroma elegido) */
    function imgVisible() {
      var ims = Array.prototype.slice.call(document.querySelectorAll('.florema-pdp-gallery__slide img'));
      for (var i = 0; i < ims.length; i++) { var r = ims[i].getBoundingClientRect(); if (r.width > 20 && r.bottom > 80 && r.top < innerHeight - 80) return ims[i]; }
      return $('.fl-rf-dt.on img') || $('.florema-pdp-gallery__slide.is-active img');
    }
    // ficha de producto (el envío lo sigue haciendo florema-cart.js)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement) || (form.getAttribute('action') || '').indexOf('/cart/add') < 0) return;
      var btn = form.querySelector('button[type="submit"]');
      var desde = window.__flFlyDesde; window.__flFlyDesde = null; // la barra fija avisa desde qué miniatura volar
      var img = (desde && desde.getBoundingClientRect().width > 20 ? desde : null) || imgVisible() || $('.florema-pdp-gallery__main img');
      if (btn) { btn.classList.remove('fl-added'); restart(btn, 'fl-adding'); }
      fly(img, btn);
      var label = btn && btn.querySelector('[data-pdp-add-text]');
      var original = label ? label.innerHTML : null;
      setTimeout(function () {
        if (!btn) return;
        btn.classList.remove('fl-adding'); btn.classList.add('fl-added');
        if (label) label.innerHTML = '✓ Agregado';
        setTimeout(function () { btn.classList.remove('fl-added'); if (label && original !== null) label.innerHTML = original; }, 1500);
      }, 900);
    }, true);
    // tarjetas de producto (+ rápido)
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-florema-card-add]');
      if (!b) return;
      var card = b.closest('.florema-card');
      fly(card && card.querySelector('.florema-card__media img'));
    }, true);
    // el número del carro salta cuando cambia
    var countEl = $('[data-cart-count]');
    if (countEl && window.MutationObserver) {
      var last = countEl.textContent;
      new MutationObserver(function () { if (countEl.textContent !== last) { last = countEl.textContent; restart(countEl, 'fl-pop'); } })
        .observe(countEl, { childList: true, characterData: true, subtree: true });
    }

    /* ---------- 2. precio que baja ---------- */
    var amt = $('.florema-pdp__price-amount'), cmp = $('.florema-pdp__price-compare'), dsc = $('.florema-pdp__price-discount');
    if (amt && cmp && num(cmp.textContent) > num(amt.textContent) && !reduce) {
      var to = num(amt.textContent), from = num(cmp.textContent), finalText = amt.textContent;
      var run = function () {
        cmp.classList.add('fl-strike');
        var t0 = null, lastSet = null;
        var step = function (t) {
          if (t0 === null) t0 = t;
          if (lastSet !== null && amt.textContent !== lastSet) return; // otro script cambió el precio (variante): no pisar
          var k = Math.min(1, (t - t0) / 1100), ease = 1 - Math.pow(1 - k, 3);
          lastSet = k < 1 ? clp(from + (to - from) * ease) : finalText;
          amt.textContent = lastSet;
          if (k < 1) requestAnimationFrame(step); else if (dsc) restart(dsc, 'fl-pop');
        };
        amt.textContent = clp(from); lastSet = amt.textContent;
        setTimeout(function () { requestAnimationFrame(step); }, 350);
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); run(); } }, { threshold: 0.6 });
        io.observe(amt);
      } else run();
    }

    /* ---------- 3. aroma que se desliza ---------- */
    // En reposo cada chip usa su propio estilo; la pastilla solo existe durante el movimiento
    // y se ubica en el momento del toque (así nunca queda desfasada).
    var grid = $('.florema-pdp-aromas__grid');
    var activeChip = grid && $('.florema-pdp-aroma.is-active', grid);
    if (grid && activeChip) {
      var pill = document.createElement('span'); pill.className = 'fl-aro-pill'; grid.insertBefore(pill, grid.firstChild);
      grid.classList.add('fl-aro-ready');
      var place = function (el) {
        var g = grid.getBoundingClientRect(), r = el.getBoundingClientRect();
        pill.style.width = r.width + 'px'; pill.style.height = r.height + 'px';
        pill.style.transform = 'translate(' + (r.left - g.left) + 'px,' + (r.top - g.top) + 'px)';
      };
      var reset = function () {
        pill.classList.remove('is-on', 'is-moving');
        $$('.florema-pdp-aroma', grid).forEach(function (x) { x.classList.remove('fl-aro-target', 'fl-aro-leaving'); });
      };
      window.addEventListener('pageshow', function (e) { if (e.persisted) reset(); });
      $$('.florema-pdp-aroma', grid).forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (a === activeChip || e.metaKey || e.ctrlKey || e.shiftKey || reduce) return;
          e.preventDefault();
          reset();
          pill.classList.remove('is-moving'); place(activeChip); pill.classList.add('is-on');
          void pill.offsetWidth;
          activeChip.classList.add('fl-aro-leaving'); a.classList.add('fl-aro-target');
          pill.classList.add('is-moving'); place(a);
          setTimeout(function () { location.href = a.href; }, 400);
        });
      });
    }

    /* ---------- 4. cantidad que rueda ---------- */
    var qty = $('[data-pdp-qty-input]');
    if (qty) {
      var prev = parseInt(qty.value, 10) || 1;
      qty.addEventListener('change', function () {
        var v = parseInt(qty.value, 10) || 1;
        if (v !== prev) restart(qty, v > prev ? 'fl-roll-up' : 'fl-roll-down');
        prev = v;
      });
    }

    /* ---------- 5. favoritos ---------- */
    var KEY = 'flFavs';
    function getFavs() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function setFavs(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} renderFavCount(); }
    var favBtnHdr = null, favCount = null, panel = null;
    var actions = $('.florema-hdr__actions');
    if (actions && cartIcon) {
      favBtnHdr = document.createElement('button');
      favBtnHdr.type = 'button'; favBtnHdr.className = 'florema-hdr__action fl-fav-hdr'; favBtnHdr.setAttribute('aria-label', 'Favoritos');
      favBtnHdr.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10Z"/></svg><span class="fl-fav-count" hidden>0</span>';
      cartIcon.parentNode.insertBefore(favBtnHdr, cartIcon);
      favCount = favBtnHdr.querySelector('.fl-fav-count');
      favBtnHdr.addEventListener('click', openPanel);
    }
    function renderFavCount() {
      if (!favCount) return;
      var n = getFavs().length; favCount.textContent = n; favCount.hidden = n === 0;
    }
    renderFavCount();
    function openPanel() {
      if (!panel) {
        panel = document.createElement('div'); panel.className = 'fl-fav-panel';
        panel.innerHTML = '<div class="fl-fav-bg" data-close></div><aside class="fl-fav-box" role="dialog" aria-label="Tus favoritos"><div class="fl-fav-head"><b>Tus favoritos</b><button type="button" data-close aria-label="Cerrar">×</button></div><div class="fl-fav-list"></div></aside>';
        document.body.appendChild(panel);
        panel.addEventListener('click', function (e) {
          if (e.target.closest('[data-close]')) closePanel();
          var rm = e.target.closest('[data-rm]');
          if (rm) { setFavs(getFavs().filter(function (f) { return f.u !== rm.getAttribute('data-rm'); })); fillPanel(); syncHeart(); }
        });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
      }
      fillPanel(); requestAnimationFrame(function () { panel.classList.add('is-on'); });
    }
    function closePanel() { if (panel) panel.classList.remove('is-on'); }
    function fillPanel() {
      var list = getFavs(), box = $('.fl-fav-list', panel);
      box.innerHTML = list.length ? list.map(function (f) {
        return '<div class="fl-fav-item"><a href="' + f.u + '"><img src="' + f.i + '" alt=""></a><a href="' + f.u + '" class="fl-fav-t">' + f.t + '<small>' + (f.p || '') + '</small></a><button type="button" data-rm="' + f.u + '" aria-label="Quitar">×</button></div>';
      }).join('') : '<p class="fl-fav-empty">Aún no guardas favoritos. Toca el ♡ en un producto para guardarlo aquí.</p>';
    }
    var title = $('.florema-pdp__title'), gal = $('.florema-pdp-gallery__main'), heart = null;
    function curItem() {
      var img = $('.florema-pdp-gallery__slide img');
      return { u: location.pathname.replace(/\/$/, ''), t: (title.textContent || '').trim(), i: img ? (img.currentSrc || img.src) : '', p: amt ? (amt.getAttribute('data-final') || finalPrice()) : '' };
    }
    function finalPrice() { return amt ? amt.textContent.trim() : ''; }
    function isFav() { var u = location.pathname.replace(/\/$/, ''); return getFavs().some(function (f) { return f.u === u; }); }
    function syncHeart() { if (heart) { var v = isFav(); heart.classList.toggle('is-on', v); heart.setAttribute('aria-pressed', v ? 'true' : 'false'); } }
    if (title && gal) {
      heart = document.createElement('button');
      heart.type = 'button'; heart.className = 'fl-heart'; heart.setAttribute('aria-label', 'Guardar en favoritos');
      heart.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10Z"/></svg>' + new Array(9).join('<i></i>');
      $$('i', heart).forEach(function (p, k) { p.style.setProperty('--a', (k * 45) + 'deg'); });
      gal.appendChild(heart); syncHeart();
      heart.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var list = getFavs(), it = curItem();
        if (isFav()) { setFavs(list.filter(function (f) { return f.u !== it.u; })); toast('Quitado de favoritos'); }
        else { list.unshift(it); setFavs(list.slice(0, 30)); restart(heart, 'fl-burst'); toast('Guardado en favoritos ♡'); if (favBtnHdr) restart(favBtnHdr, 'fl-bump'); }
        syncHeart();
      });
    }

    /* ---------- 6. cuenta regresiva que voltea ---------- */
    if (!reduce && window.MutationObserver) {
      $$('[data-florema-cyber-timer] b, [data-florema-pdp-countdown] .florema-pdp-countdown__n').forEach(function (el) {
        var v = el.textContent;
        new MutationObserver(function () { if (el.textContent !== v) { v = el.textContent; restart(el, 'fl-flip'); } })
          .observe(el, { childList: true, characterData: true, subtree: true });
      });
    }
    /* ---------- 7. encabezado compacto al bajar ---------- */
    // Arriba: completo. Al bajar: se esconden la cinta y la franja de despacho (quedan contador Cyber + logo/carro).
    // El espacio reservado se congela en el alto completo para que la página no salte.
    var hdrEl = $('.florema-hdr');
    if (hdrEl) {
      var compact = false, root = document.documentElement;
      var setFull = function () { if (!compact) root.style.setProperty('--fl-hdr-full', hdrEl.offsetHeight + 'px'); };
      setFull(); window.addEventListener('resize', setFull, { passive: true });
      var menuOpen = function () { return !!document.querySelector('.florema-hdr__mobile.is-open'); };
      var onHdrScroll = function () {
        var y = window.scrollY || 0;
        if (!compact && y > 140 && !menuOpen()) {
          setFull(); compact = true; root.classList.add('fl-compacto');
          setTimeout(function () { window.dispatchEvent(new Event('scroll')); }, 350);
        } else if (compact && y < 40) {
          compact = false; root.classList.remove('fl-compacto');
          setTimeout(function () { setFull(); window.dispatchEvent(new Event('scroll')); }, 350);
        }
      };
      // La barra fija de "Agregar al carro" (escritorio) toma el alto del encabezado solo al cargar:
      // al achicarse el encabezado quedaba un hueco. Se reajusta cada vez que cambia el alto.
      var syncSticky = function () {
        var st = document.querySelector('[data-pdp-sticky]');
        if (!st || window.innerWidth < 750) return;
        if (!st.__flTop) { st.__flTop = 1; var tr = getComputedStyle(st).transition; st.style.transition = (tr && tr !== 'all 0s ease 0s' ? tr + ',' : '') + 'top .3s ease'; }
        st.style.top = Math.max(0, Math.round(hdrEl.getBoundingClientRect().bottom)) + 'px';
      };
      hdrEl.addEventListener('transitionend', syncSticky);
      window.addEventListener('resize', function () { setTimeout(syncSticky, 50); }, { passive: true });
      new MutationObserver(function () { syncSticky(); setTimeout(syncSticky, 380); })
        .observe(root, { attributes: true, attributeFilter: ['class'] });
      setTimeout(syncSticky, 100);
      var hdrTick = false;
      window.addEventListener('scroll', function () { if (!hdrTick) { hdrTick = true; requestAnimationFrame(function () { onHdrScroll(); hdrTick = false; }); } }, { passive: true });
      onHdrScroll();
    }
    /* ---------- 8b. estilo Polène: encabezado transparente arriba, vidrio al bajar ---------- */
    if (document.documentElement.classList.contains('fl-polene')) {
      var onBajo = function () { document.documentElement.classList.toggle('fl-bajo', (window.scrollY || 0) > 8); };
      window.addEventListener('scroll', onBajo, { passive: true }); onBajo();
    }
    /* ---------- 8. galería de producto estilo Polène (solo vista previa ?estilo=polene) ---------- */
    // En celular la foto va a todo el ancho por detrás del encabezado: puntitos + deslizar en vez de miniaturas.
    var gal = $('.fl-polene .florema-pdp-gallery');
    var galMain = gal && $('.florema-pdp-gallery__main', gal);
    var thumbs = gal ? [].slice.call(gal.querySelectorAll('[data-pdp-thumb]')) : [];
    if (galMain) {
      // Láminas con texto (perfil de aroma, nombre de archivo = handle del producto): se muestran completas
      var hnd = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0].toLowerCase();
      [].forEach.call(galMain.querySelectorAll('.florema-pdp-gallery__slide img'), function (im) {
        var src = (im.currentSrc || im.src || '').toLowerCase();
        if ((hnd && /^[^?]*\/([^/?]+)$/.test(src.split('?')[0]) && src.split('?')[0].split('/').pop().replace(/\.(png|jpe?g|webp)$/, '').replace(/_[0-9a-f]{8}-[0-9a-f-]{27}$/, '') === hnd) || /^perfil-aroma/.test(im.alt || '')) im.parentNode.classList.add('fl-lamina');
      });
      var gut = parseFloat(getComputedStyle($('.florema-pdp') || document.body).paddingLeft) || 0;
      document.documentElement.style.setProperty('--fl-pdp-gut', gut + 'px');
      // Reflejo difuminado sobre la foto (bajo el encabezado): cada lámina usa su propia imagen
      [].forEach.call(galMain.querySelectorAll('.florema-pdp-gallery__slide'), function (sl) {
        var im = sl.querySelector('img'); if (!im) return;
        var u = (im.getAttribute('src') || '').replace(/([?&])width=\d+/, '$1width=600');
        sl.style.setProperty('--fl-bg', 'url("' + u.replace(/"/g, '%22') + '")');
      });
      var setGalW = function () {
        var cb = $('.florema-hdr .florema-cyber-bar');
        if (!document.documentElement.classList.contains('fl-compacto')) document.documentElement.style.setProperty('--fl-cyber-h', (cb ? cb.offsetHeight : 0) + 'px');
        document.documentElement.style.setProperty('--fl-gal-w', galMain.clientWidth + 'px');
      };
      setGalW(); window.addEventListener('resize', setGalW, { passive: true });
    }
    if (galMain && thumbs.length > 1) {
      var dots = document.createElement('div'); dots.className = 'fl-gal-dots';
      thumbs.forEach(function (t, i) {
        var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Imagen ' + (i + 1));
        d.addEventListener('click', function () { t.click(); });
        dots.appendChild(d);
      });
      galMain.appendChild(dots);
      var syncDots = function () { thumbs.forEach(function (t, i) { dots.children[i].classList.toggle('is-on', t.classList.contains('is-active')); }); };
      syncDots();
      thumbs.forEach(function (t) { new MutationObserver(syncDots).observe(t, { attributes: true, attributeFilter: ['class'] }); });
      // Deslizar con el dedo o arrastrar con el mouse (eventos pointer cubren ambos)
      var x0 = null, y0 = null, arrastro = false;
      galMain.addEventListener('dragstart', function (e) { e.preventDefault(); });
      galMain.addEventListener('pointerdown', function (e) {
        if (e.button && e.button !== 0) return;
        if (e.target.closest && e.target.closest('button,a')) return;
        x0 = e.clientX; y0 = e.clientY; arrastro = false;
      });
      var soltar = function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        arrastro = true;
        var cur = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
        thumbs[(cur + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length].click();
      };
      galMain.addEventListener('pointerup', soltar);
      window.addEventListener('pointerup', function (e) { if (x0 !== null) soltar(e); });
      galMain.addEventListener('pointercancel', function () { x0 = null; });
      // si fue arrastre, que el clic no abra nada (zoom, etc.)
      galMain.addEventListener('click', function (e) { if (arrastro) { e.preventDefault(); e.stopPropagation(); arrastro = false; } }, true);
    }
  });
  /* ================= micro-animaciones · fase 2 (10-oct-2026) =================
     7) carro lateral (fila ocupada, eliminar que se cierra, números que ruedan, regalo que late, vacío limpio)
     8) botones "Agregar" de las tarjetas   9) acordeones que se abren suave   10) filtros
     11) reseñas que entran                12) packs: segundo aroma que se despliega   13) "Cambiar" de la barra fija */
  ready(function () {
    function anima(el, kf, op) { try { return el.animate(kf, op); } catch (e) { return null; } }
    function vigila(el, fn, attrs) { if (el && window.MutationObserver) new MutationObserver(fn).observe(el, attrs || { childList: true, characterData: true, subtree: true }); }

    /* ---------- 7. carro lateral ---------- */
    var drawer = $('[data-florema-cart-drawer]');
    var itemsEl = drawer && $('[data-florema-cart-items]', drawer);
    if (drawer && itemsEl) {
      /* identidad de cada línea = id de la variante (la "key" de Shopify cambia cuando el tema reescribe el "Ahorras" de la línea) */
      var vid = function (k) { return String(k || '').split(':')[0]; };
      var leer = function () { var m = {}; $$('[data-key]', itemsEl).forEach(function (r) { var i = $('[data-qty-input]', r); m[vid(r.getAttribute('data-key'))] = i ? parseInt(i.value, 10) || 0 : 0; }); return m; };
      var cantidades = leer();
      /* + y − al instante: el número, el total de la línea y el total del carro cambian en el acto
         (optimista) y la tienda se actualiza por detrás con UNA sola llamada aunque se toque varias veces.
         "deseado" guarda lo que eligió el cliente hasta que la tienda lo confirma. */
      var deseado = {}, timers = {}, cola = Promise.resolve();
      var precioDe = function (t) { var d = String(t || '').replace(/[^\d]/g, ''); return d ? parseInt(d, 10) : 0; };
      var ponTexto = function (el, v) { if (el) { el.textContent = clp(v); restart(el, 'fl-num'); } };
      var filaDe = function (v) { return $$('[data-key]', itemsEl).filter(function (r) { return vid(r.getAttribute('data-key')) === v; })[0]; };
      // el tema reescribe la propiedad "Precio normal" con la cantidad que tenía un momento antes: si el cliente
      // eligió otra, esa llamada lleva la cantidad elegida (si no, devolvía el carro a la cantidad vieja)
      if (window.fetch && !window.__flFetchCarro) {
        window.__flFetchCarro = true;
        var fOrig = window.fetch;
        window.fetch = function (u, o) {
          try {
            if (o && typeof o.body === 'string' && /\/cart\/change/.test(String(u && u.url || u))) {
              var bd = JSON.parse(o.body);
              if (bd && bd.id && bd.properties && (vid(bd.id) in deseado) && bd.quantity > 0) {
                bd.quantity = deseado[vid(bd.id)];
                o = Object.assign({}, o, { body: JSON.stringify(bd) });
              }
            }
          } catch (er) {}
          return fOrig.call(this, u, o);
        };
      }
      var enviar = function (v) {
        cola = cola.then(function () {
          var r = filaDe(v), quiero = deseado[v];
          if (!r || quiero == null) return;
          var linea = parseInt(r.getAttribute('data-line'), 10);
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: linea, quantity: quiero }) })
            .catch(function () {})
            .then(function () { return window.FloremaCart && window.FloremaCart.refresh(); });
        });
      };
      drawer.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-qty-plus],[data-qty-minus]');
        if (!b) return;
        var row = b.closest('[data-key]'), inp = row && $('[data-qty-input]', row);
        if (!row || !inp || !window.fetch) return;
        var v = vid(row.getAttribute('data-key')), q = parseInt(inp.value, 10) || 1;
        var n = b.hasAttribute('data-qty-plus') ? q + 1 : q - 1;
        if (n < 1) { delete deseado[v]; return; } // bajar a 0 = eliminar: lo hace el tema (con la fila que se cierra, abajo)
        e.preventDefault(); e.stopPropagation();
        // números nuevos al tiro
        inp.value = n; restart(inp, n > q ? 'fl-roll-up' : 'fl-roll-down');
        var fin = $('.florema-cart-drawer__item-total-final', row) || $('.florema-cart-drawer__item-total', row);
        var ori = $('.florema-cart-drawer__item-total-original', row);
        var uni = fin ? precioDe(fin.textContent) / q : 0;
        if (fin && uni && !/regalo/i.test(fin.textContent)) {
          ponTexto(fin, uni * n);
          if (ori) ponTexto(ori, precioDe(ori.textContent) / q * n);
          var tot = $('[data-florema-cart-total]', drawer);
          if (tot) ponTexto(tot, precioDe(tot.textContent) + uni * (n - q));
          var sv = $('[data-florema-cart-savings] [data-v]', drawer);
          if (sv && ori) ponTexto(sv, precioDe(sv.textContent) + (precioDe(ori.textContent) / n - uni) * (n - q));
        }
        deseado[v] = n; cantidades[v] = n;
        clearTimeout(timers[v]);
        timers[v] = setTimeout(function () { timers[v] = null; enviar(v); }, 450);
      }, true);
      // al tocar eliminar (o bajar de 1 a 0): la fila se aclara y se cierra suave
      drawer.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-qty-minus],[data-remove]');
        if (!b) return;
        var row = b.closest('[data-key]'); if (!row) return;
        var inp = $('[data-qty-input]', row), q = inp ? parseInt(inp.value, 10) || 1 : 1;
        if (b.hasAttribute('data-qty-minus') && q > 1) return;
        row.classList.add('fl-busy');
        if (!reduce) {
          var h = row.offsetHeight;
          row.style.overflow = 'hidden';
          anima(row, [{ height: h + 'px', opacity: 1, transform: 'none' }, { height: '0px', opacity: 0, transform: 'translateX(24px)', paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: '0px' }], { duration: 320, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' });
        }
      }, true);
      // después de cada recarga del carro: lo que cambió se mueve, lo nuevo entra
      vigila(itemsEl, function () {
        // lo que la tienda ya confirmó deja de estar pendiente; lo demás se respeta en pantalla
        $$('[data-key]', itemsEl).forEach(function (r) {
          var v = vid(r.getAttribute('data-key')), i = $('[data-qty-input]', r); if (!i || !(v in deseado)) return;
          if (parseInt(i.value, 10) === deseado[v] && !timers[v]) delete deseado[v]; else i.value = deseado[v];
        });
        var nuevo = leer(), habia = Object.keys(cantidades).length;
        $$('[data-key]', itemsEl).forEach(function (r) {
          var k = vid(r.getAttribute('data-key'));
          if (!(k in cantidades)) { if (habia && !reduce) anima(r, [{ opacity: 0, transform: 'translateX(20px)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: 'cubic-bezier(0,0,.3,1)' }); return; }
          if (cantidades[k] !== nuevo[k]) {
            restart($('[data-qty-input]', r), nuevo[k] > cantidades[k] ? 'fl-roll-up' : 'fl-roll-down');
            restart($('.florema-cart-drawer__item-total', r), 'fl-num');
          }
        });
        cantidades = nuevo;
        var em = $('.florema-cart-drawer__empty', itemsEl);
        drawer.classList.toggle('fl-vacio', !!em);
        if (em && !$('.fl-vacio-cta', em)) {
          var a = document.createElement('a'); a.href = '/collections/all'; a.className = 'fl-vacio-cta'; a.textContent = 'Ver productos';
          em.appendChild(a);
        }
      }, { childList: true });
      // números del pie que ruedan
      [$('[data-florema-cart-total]', drawer), $('[data-florema-cart-savings] [data-v]', drawer)].forEach(function (n) {
        if (!n) return; var t = n.textContent;
        vigila(n, function () { if (n.textContent !== t) { t = n.textContent; restart(n, 'fl-num'); } });
      });
      // el regalo late cuando se gana
      var prog = $('[data-florema-cart-progress-text]', drawer);
      if (prog) {
        var gano = /Ganaste|desbloqueado|Ya tienes/i.test(prog.textContent);
        vigila(prog, function () {
          var g = /Ganaste|desbloqueado|Ya tienes/i.test(prog.textContent);
          if (g && !gano) restart(prog, 'fl-gano');
          gano = g;
        });
      }
      if ($('.florema-cart-drawer__empty', itemsEl)) drawer.classList.add('fl-vacio');
    }

    /* ---------- 8. botones "Agregar" de las tarjetas ---------- */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-florema-card-add]');
      if (!b || b.disabled) return;
      b.classList.add('fl-cargando');
      var t0 = Date.now();
      var mira = setInterval(function () {
        if (Date.now() - t0 > 120 && (b.classList.contains('is-added') || !b.disabled || Date.now() - t0 > 6000)) { b.classList.remove('fl-cargando'); clearInterval(mira); }
      }, 80);
    }, true);

    /* ---------- 9. acordeones que se abren y cierran suave ---------- */
    var ACC = '.florema-pdp-accordion__item, .florema-page-faq__item, .fl-acc, .florema-hdr__mobile details, .florema-pdp-accordion details';
    document.addEventListener('click', function (e) {
      if (reduce || e.defaultPrevented) return;
      var s = e.target.closest && e.target.closest('summary');
      var d = s && s.parentNode;
      if (!d || d.tagName !== 'DETAILS' || !d.matches(ACC) || s !== d.querySelector('summary')) return;
      var inner = e.target.closest('a,button,input');
      if (inner && s.contains(inner)) return;
      e.preventDefault();
      if (d.__flAn) d.__flAn.cancel();
      var abriendo = !d.open || d.classList.contains('fl-cerrando');
      var desde = d.getBoundingClientRect().height;
      d.classList.remove('fl-cerrando');
      var hasta;
      if (abriendo) { d.open = true; hasta = d.getBoundingClientRect().height; }
      else {
        d.classList.add('fl-cerrando');
        var cs = getComputedStyle(d);
        hasta = s.getBoundingClientRect().height + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth) + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
      }
      d.style.overflow = 'hidden'; d.style.boxSizing = 'border-box';
      var limpia = function () { d.style.overflow = ''; d.style.boxSizing = ''; };
      var an = d.__flAn = anima(d, [{ height: desde + 'px' }, { height: hasta + 'px' }], { duration: abriendo ? 320 : 260, easing: 'cubic-bezier(.4,0,.2,1)' });
      var fin = function () { d.__flAn = null; limpia(); if (!abriendo) { d.open = false; d.classList.remove('fl-cerrando'); } };
      if (an) { an.onfinish = fin; an.oncancel = limpia; } else fin();
      if (abriendo) { var cuerpo = s.nextElementSibling; if (cuerpo) anima(cuerpo, [{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: 'ease-out' }); }
    });

    /* ---------- 10. filtros de colecciones ---------- */
    var coll = $('[data-fl-coll]');
    if (coll) {
      var ultimo = null;
      coll.addEventListener('change', function (e) { var i = e.target; if (i && i.matches && i.matches('input[data-k]')) ultimo = i.dataset.k + '|' + i.value; }, true);
      var grupos = $('[data-fl-groups]', coll);
      vigila(grupos, function () {
        if (!ultimo) return;
        var u = ultimo; ultimo = null;
        $$('input[data-k]', grupos).forEach(function (i) { if (i.dataset.k + '|' + i.value === u) i.classList.add('fl-recien'); });
      }, { childList: true });
      // los productos que quedan entran con un fundido escalonado
      var res = $('[data-fl-results]', coll);
      if (res) {
        var nRes = res.textContent;
        vigila(res, function () {
          if (res.textContent === nRes) return; nRes = res.textContent;
          if (reduce) return;
          var k = 0;
          $$('[data-fl-item]', coll).forEach(function (it) {
            if (it.hidden || it.style.display === 'none' || k > 15) return;
            var c = it.firstElementChild; if (!c) return;
            anima(c, [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 380, delay: Math.min(k, 8) * 40, easing: 'cubic-bezier(0,0,.3,1)', fill: 'backwards' });
            k++;
          });
        });
      }
      // el número del botón "Filtrar" da un saltito
      $$('[data-fl-active-count]', coll).forEach(function (c) { var t = c.textContent; vigila(c, function () { if (c.textContent !== t) { t = c.textContent; if (t) restart(c, 'fl-pop'); } }); });
      // el panel se va deslizando en vez de desaparecer
      $$('[data-fl-drawer]', coll).forEach(function (dw) {
        var cerrando = false;
        new MutationObserver(function () {
          if (dw.hidden && !cerrando && !reduce && dw.__flVisto) {
            cerrando = true; dw.hidden = false;
            var p = $('.fl-drawer__panel', dw), o = $('.fl-drawer__overlay', dw);
            var a1 = o ? anima(o, [{ opacity: 1 }, { opacity: 0 }], { duration: 260, fill: 'forwards' }) : null;
            var a2 = p ? anima(p, [{ transform: 'none' }, { transform: 'translateX(100%)' }], { duration: 260, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' }) : null;
            setTimeout(function () { dw.hidden = true; if (a1) a1.cancel(); if (a2) a2.cancel(); dw.__flVisto = false; cerrando = false; }, 270);
          } else if (!dw.hidden) dw.__flVisto = true;
        }).observe(dw, { attributes: true, attributeFilter: ['hidden'] });
      });
    }

    /* ---------- 11. reseñas: las nuevas entran escalonadas ---------- */
    var rv = $('[data-florema-pdp-reviews-grid]');
    if (rv && !reduce && window.WeakSet) {
      var vistas = new WeakSet();
      $$('.florema-pdp-review', rv).forEach(function (x) { vistas.add(x); });
      vigila(rv, function () {
        var k = 0;
        $$('.florema-pdp-review', rv).forEach(function (x) {
          if (vistas.has(x)) return; vistas.add(x);
          if (x.offsetParent === null) return;
          anima(x, [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: Math.min(k++, 6) * 70, easing: 'cubic-bezier(0,0,.3,1)', fill: 'backwards' });
        });
      }, { childList: true });
    }

    /* ---------- 12. packs: "Usar mismo aroma" despliega y recoge el segundo selector ---------- */
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-same-aroma-toggle]');
      if (!t || reduce) return;
      var abrir = t.getAttribute('aria-pressed') === 'true'; // el tema lo invierte justo después de este clic
      var resto = $$('.florema-pdp__option').slice(1);
      if (abrir) {
        setTimeout(function () {
          resto.forEach(function (o) {
            var h = o.getBoundingClientRect().height; if (!h) return;
            o.style.overflow = 'hidden';
            var an = anima(o, [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 340, easing: 'cubic-bezier(.4,0,.2,1)' });
            if (an) an.onfinish = function () { o.style.overflow = ''; }; else o.style.overflow = '';
          });
        }, 0);
      } else {
        // recoger: se anima una copia inerte mientras el original ya quedó oculto por el tema
        resto.forEach(function (o) {
          var h = o.getBoundingClientRect().height; if (!h) return;
          var c = o.cloneNode(true);
          c.removeAttribute('id'); $$('[id]', c).forEach(function (x) { x.removeAttribute('id'); });
          $$('input,select,button', c).forEach(function (x) { x.removeAttribute('name'); x.disabled = true; });
          $$('[data-pdp-variant-input]', c).forEach(function (x) { x.removeAttribute('data-pdp-variant-input'); });
          c.classList.remove('florema-pdp__option--hidden'); c.style.overflow = 'hidden'; c.style.pointerEvents = 'none'; c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-pdp-option');
          o.parentNode.insertBefore(c, o);
          var an = anima(c, [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 280, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' });
          if (an) an.onfinish = function () { c.remove(); }; else c.remove();
        });
      }
    }, true);

    /* ---------- 13. "Cambiar" de la barra fija: el selector brilla al llegar ---------- */
    document.addEventListener('click', function (e) {
      if (!(e.target.closest && e.target.closest('[data-pdp-sticky-change]'))) return;
      var dest = $('.florema-pdp__option') || $('.florema-pdp-aromas') || $('.florema-pdp__variants');
      if (!dest) return;
      var hecho = false, t;
      var marca = function () { if (hecho) return; hecho = true; window.removeEventListener('scroll', alMover); restart(dest, 'fl-aqui'); setTimeout(function () { dest.classList.remove('fl-aqui'); }, 1600); };
      var alMover = function () { clearTimeout(t); t = setTimeout(marca, 140); };
      window.addEventListener('scroll', alMover, { passive: true });
      t = setTimeout(marca, 700);
    });
  });
})();
